export const RESTAURANT_CLOSE_TEXT = "Outlet will stop taking orders in";
export const RESTAURANT_CLOSED = "Restaurant Has Been Closed";
export const ICON_SIZE = 18;
export const CART_TIMER_CLOSING_TIME = "cart_timer_closing_time";
export const CART_TIMER_DURATION_TIME = "cart_timer_duration_time";

export enum Source {
    CART = "cart",
    PAYMENT = "payments",
    PAY_HALF_CARD = "payments_half_card",
}
export const CART_TIMER_TEST_IDS = {
    CART_TIMER_WRAPER: "CART_TIMER_WRAPPER",
    CART_TIMER_TEXT: "CART_TIMER_TEXT",
};
